"use client"
import { useState } from 'react'
import AppIcon from '../AppIcon'
import ChevronIcon from '../../homepage/components/ChevronIcon'

interface Source {
    name: string
    url: string
    linkText: string
    consultedDate: string
}

interface OtherSourcesProps {
    intro: string
    sources: Source[]
}

const VISIBLE_COUNT = 3

const SourceItem = ({ source, index }: { source: Source; index: number }) => {
    const date = new Date(source.consultedDate)
    const hasValidDate = !isNaN(date.getTime())

    return (
        <li className="text-blue-550 list-none">
            <AppIcon
                iconClassName={`fa-square-${index + 1}`}
                type="regular"
                className="inline-block mr-2 align-middle"
            />
            {source.name}{" "}
            <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-550 break-words"
            >
                {source.linkText}
            </a>
            {hasValidDate && <> Consulté le {date.toLocaleDateString("fr-FR")}</>}
        </li>
    )
}

const OtherSources = ({ intro, sources }: OtherSourcesProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
    }

    const visibleSources = sources.slice(0, VISIBLE_COUNT)
    const extraSources = sources.slice(VISIBLE_COUNT)
    const hasMore = extraSources.length > 0

    return (
        <div className="bg-blue-100 p-4 flex flex-col gap-2 mb-rm-50 rounded-2xl border border-rm-blue text-pale">
            <div className="flex items-center justify-between">
                <div className="font-semibold title-look">Sources de l'article</div>
            </div>

            <div>
                {intro && <p className="pb-0 mt-0">{intro}</p>}
                <ul className="space-y-2 pl-0">
                    {visibleSources.map((source, index) => (
                        <SourceItem source={source} index={index} key={index} />
                    ))}
                    {hasMore &&
                        isOpen &&
                        extraSources.map((source, index) => (
                            <SourceItem
                                source={source}
                                index={index + VISIBLE_COUNT}
                                key={index + VISIBLE_COUNT}
                            />
                        ))}
                </ul>

                {hasMore && (
                    <button
                        type="button"
                        onClick={toggleIsOpen}
                        className="mt-3 inline-flex items-center gap-2 underline text-blue-550 cursor-pointer"
                    >
                        {isOpen ? "Voir moins de sources" : "Voir plus de sources"}
                        <ChevronIcon open={isOpen} />
                    </button>
                )}
            </div>
        </div>
    )
}

export default OtherSources
